<template>
  <div>
    <ButtonTooltip
      color="primary"
      :icon="!hasFile ? 'add' : 'edit'"
      :type="!hasFile ? 'add' : 'edit'"
      :tooltip="!hasFile ? $t('adminVideo.buttons.addFile') : $t('adminVideo.buttons.modifyFile')"
      v-on:event-click="buttonTrigger"
      :disabled="disabled || uploadLoading"
    />
    <input :id="indexName" :accept="acceptFiles" type="file" class="hidden-input" />
  </div>
</template>

<script>
import ButtonTooltip from '@/components/adminVideo/ButtonTooltip'

export default {
  name: 'ButtonTooltipWithInput',

  components: {
    ButtonTooltip
  },

  props: {
    indexName: String,
    disabled: Boolean,
    uploadLoading: Boolean,
    hasFile: Boolean
  },

  mounted() {
    document.getElementById(this.indexName).addEventListener('change', this.addFile)
  },

  computed: {
    acceptFiles() {
      if (this.indexName === 'audio') {
        return '.mp3,.wav'
      } else {
        return 'video/mp4,video/x-m4v,video/*'
      }
    }
  },

  methods: {
    buttonTrigger(type) {
      if (type === 'add' || type === 'edit') {
        const el = document.getElementById(this.indexName).click()
      }
    },
    addFile(e) {
      const el = document.getElementById(this.indexName)
      const droppedFiles = (e.dataTransfer && e.dataTransfer.files) || (e.target && e.target.files)
      if (!droppedFiles) return

      const file = droppedFiles[0]
      if (!file) return
      const sizeInMB = parseInt((file.size / (1024 * 1024)).toFixed(2))

      if (sizeInMB > 5000) {
        this.$emit('upload-size-error', true)
        el.value = ''
        return
      }

      this.$emit('upload-size-error', false)

      const data = {
        mediaType: this.indexName,
        mediaFile: file
      }

      const success = this.$store.dispatch('adminVideo/sendMedia', data)
      if (!success) {
      } else {
      }

      el.value = ''
    }
  }
}
</script>

<style lang="sass" scoped>
.hidden-input
  position: absolute
  width: 0
  height: 0
  visibility: hidden
</style>
